'use client';

import React, { useEffect, useRef } from 'react';
import { cn } from '@/lib/utils';

const DEFAULT_FORM_ID = '691b8a3390c9a23fda0e3db3';

interface Marketing360FormProperties {
  className?: string;
  formId?: string;
}

function Marketing360Form({ className, formId = DEFAULT_FORM_ID }: Marketing360FormProperties) {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const script = document.createElement('script');
    script.src = `https://forms.marketing360.com/load.js?id=${formId}`;
    script.async = true;
    container.appendChild(script);

    return () => {
      if (container) {
        container.innerHTML = '';
      }
    };
  }, [formId]);

  return <div ref={containerRef} className={cn('w-full', className)} />;
}

export default Marketing360Form;
